<template>
  <button class="my-button" @click="handleClick" :disabled="(!clickable && disabled)|| loading" :autofocus="autofocus"
    :type="nativeType" :class="[
      type ? 'my-button--' + type : '',
      theme ? 'my-button--theme-'+theme : '',
      {
        'is-disabled': disabled,
        'is-loading': loading,
        'is-plain': plain,
        'is-round': round,
        'is-circle': circle
      }
    ]">
    <i class="icon-loading" v-if="loading">
      <svg viewBox="25 25 50 50" class="van-loading__circular">
        <circle cx="50" cy="50" r="20" fill="none"></circle>
      </svg>
    </i>
    <svg-icon :icon-class="icon" :style="{fontSize:iconSize}" class="icon" v-if="icon && !loading">
    </svg-icon>
    <span v-if="$slots.default">
      <slot></slot>
    </span>
  </button>
</template>
<script>
export default {
  name: 'myButton',

  props: {
    // 按钮类型：主按钮，线框按钮，次按钮，文本按钮，链接按钮
    // Type： primary border default text link
    theme: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'default'
    },
    // big, medium, small, mini
    size: String,
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: 'inherit'
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
    // disabled状态也点击
    clickable: {
      type: Boolean,
      default: false
    }
  },

  mounted() {},

  methods: {
    handleClick(evt) {
      this.$emit('click', evt)
    }

  }
}
</script>
<style lang="less" scoped>
@active-color: #f09d05;
@hover-color: #f9b430;
.my-button {
  border: 1px solid @border;
  padding: 7px 4px;
  text-align: center;
  border-radius: 4px;
  transition: all 0.2s;
  cursor: pointer;
  .icon-loading {
    width: 30px;
    margin: 0 10px;
  }
  .icon {
    margin-right: 10px;
  }
  &--default {
    &:hover {
      background: #f7f8fa;
    }
    &:active {
      background: #f2f3f5;
    }
    &.is-disabled {
      color: #d9d9d9;
      opacity: 1;
      background: @bg;
    }
  }

  &--primary {
    background-color: @theme;
    color: #fff;
    border-color: transparent;
    &:hover {
      background-color: @hover-color;
    }
    &:active {
      background-color: @active-color;
    }
  }
  &--border {
    color: @theme2;
    border-color: currentColor;
    &:hover {
      // color: #fff;
      border-color: currentColor;
      // background-color: @hover-color;
    }
    &:active {
      // background-color: @active-color;
    }
    &.is-disabled {
      color: #d9d9d9;
      opacity: 1;
      background: @bg;
      border-color: @border;
    }
  }
  &--text,
  &--link {
    border: none;
    &:hover {
      color: #f6983b;
    }
    &:active {
      color: #e88523;
    }
    &.is-disabled {
      opacity: 1;
      color: @black-m;
    }
  }
  &--link {
    border: none;
    color: @theme2;
  }
  &.is-disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  &--theme-red {
    color: @red;
    border-color: currentColor;
    &:hover {
      color: #fff;
      border-color: @red;
      background-color: @red;
    }
  }
}
</style>
